var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVscodeIconsFileTypeExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7667 21.6124L15.396 18.2V43.4157C15.3962 43.6896 15.4504 43.9608 15.5555 44.2138C15.6605 44.4668 15.8143 44.6967 16.0082 44.8902C16.2021 45.0837 16.4322 45.2372 16.6853 45.3418C16.9385 45.4464 17.2098 45.5002 17.4837 45.4999H50.9087C51.183 45.5006 51.4546 45.4472 51.7082 45.3428C51.9618 45.2384 52.1923 45.085 52.3865 44.8914C52.5808 44.6978 52.7349 44.4679 52.8402 44.2146C52.9455 43.9614 52.9998 43.6899 53 43.4157V34.1249L34.7667 21.6124Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7667 7.34744e-07H17.4837C17.2098 -0.000229175 16.9385 0.0534991 16.6853 0.158118C16.4322 0.262737 16.2021 0.416198 16.0082 0.609739C15.8143 0.803279 15.6605 1.03311 15.5555 1.28611C15.4504 1.5391 15.3962 1.81031 15.396 2.08425V11.375L34.7667 22.75L45.0235 26.1625L53 22.75V11.375L34.7667 7.34744e-07Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.396 11.375H34.7667V22.75H15.396V11.375Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M29.2595 9.09998H15.396V37.5375H29.2595C29.8119 37.5347 30.341 37.3144 30.7321 36.9243C31.1232 36.5342 31.3449 36.0056 31.349 35.4532V11.1842C31.3449 10.6318 31.1232 10.1033 30.7321 9.71316C30.341 9.32303 29.8119 9.10272 29.2595 9.09998Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1202 10.2375H15.396V38.675H28.1202C28.6727 38.6723 29.2017 38.452 29.5929 38.0619C29.984 37.6717 30.2056 37.1432 30.2097 36.5908V12.3218C30.2056 11.7694 29.984 11.2409 29.5929 10.8507C29.2017 10.4606 28.6727 10.2403 28.1202 10.2375Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.1202 10.2375H15.396V36.4001H28.1202C28.6727 36.3973 29.2017 36.177 29.5929 35.7869C29.984 35.3967 30.2056 34.8682 30.2097 34.3158V12.3218C30.2056 11.7694 29.984 11.2409 29.5929 10.8507C29.2017 10.4606 28.6727 10.2403 28.1202 10.2375Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.981 10.2375H15.396V36.4001H26.981C27.5334 36.3973 28.0625 36.177 28.4536 35.7869C28.8447 35.3967 29.0664 34.8682 29.0705 34.3158V12.3218C29.0664 11.7694 28.8447 11.2409 28.4536 10.8507C28.0625 10.4606 27.5334 10.2403 26.981 10.2375Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0895 10.2376H26.981C27.5344 10.2371 28.0653 10.4564 28.4571 10.8472C28.849 11.238 29.0696 11.7684 29.0705 12.3218V33.1783C29.0696 33.7317 28.849 34.2621 28.4571 34.6529C28.0653 35.0437 27.5344 35.263 26.981 35.2625H6.0895C5.81541 35.263 5.54393 35.2094 5.29055 35.1049C5.03718 35.0004 4.80688 34.847 4.61283 34.6534C4.41878 34.4599 4.26478 34.2299 4.15962 33.9768C4.05447 33.7237 4.00023 33.4524 4 33.1783V12.3218C4.00023 12.0477 4.05447 11.7764 4.15962 11.5233C4.26478 11.2701 4.41878 11.0402 4.61283 10.8467C4.80688 10.6531 5.03718 10.4997 5.29055 10.3952C5.54393 10.2906 5.81541 10.2371 6.0895 10.2376Z",
    fill: "url(#paint0_linear_141_6313)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.475 29.5278L14.8692 22.7308L10.8442 15.9723H14.0765L16.2727 20.3C16.4757 20.7095 16.6227 21.014 16.6892 21.217H16.719C16.8625 20.888 17.0147 20.5713 17.174 20.2615L19.5225 15.9793H22.4975L18.3692 22.6993L22.6025 29.533H19.4367L16.8992 24.7888C16.7814 24.5848 16.6813 24.3711 16.6 24.15H16.558C16.484 24.3654 16.3853 24.5716 16.264 24.7643L13.6512 29.5278H10.475Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9105 2.93773e-06H34.7667V11.375H53V2.08425C52.9997 1.81017 52.9455 1.53881 52.8404 1.2857C52.7352 1.03259 52.5812 0.802684 52.3871 0.609121C52.1931 0.415558 51.9628 0.262133 51.7094 0.157617C51.4561 0.0531016 51.1846 -0.000457032 50.9105 2.93773e-06Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7667 22.75H53V34.125H34.7667V22.75Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_141_6313",
    x1: 8.3645,
    y1: 8.59955,
    x2: 24.706,
    y2: 36.9005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscodeIconsFileTypeExcel);
export default __webpack_public_path__ + "static/media/vscode-icons_file-type-excel.a1febd0a2e9bc857222f32e409a424cf.svg";
export { ForwardRef as ReactComponent };